export default __webpack_public_path__ + "static/media/san_rafael.5dea7b90.jpg";